import React from "react";
import clsx from "clsx";
import Ink from "react-ink";

import Link from "../../Link/Link";
import Text from "../../../common/Text/Text";

export default class MenuItem extends React.PureComponent {
	handleClick = (e) => {
		this.props.onSelect(e, this.props.item);
	};

	handleActive = () => {
		this.props.onActive(this.props.item);
	};

	render() {
		const {
			item,
			index,
			active,
			selected,
			noInk,
			className,
			superscriptIcons,
		} = this.props;
		item.index = index;

		const element = item.noRedirect || !item.pathName ? "button" : Link;

		const _superscriptIcon = superscriptIcons ? superscriptIcons[index] : null;

		return React.createElement(
			element,
			{
				key: item.id || index,
				tabIndex: 0,
				href: item.pathName,
				onMouseOver: this.handleActive,
				onFocus: this.handleActive,
				onClick: this.handleClick,
				disabled: item.disabled,
				className: clsx("MenuItem", className, {
					"--active": active,
					"--selected": selected,
					"--nested": item.depth >= 0,
					"--disabled": item.disabled,
				}),
				style: {
					marginLeft: item.depth >= 0 ? `${6 * (item.depth + 1)}px` : 0,
					width: `calc(100% - ${6 * (item.depth + 1)}px)`,
				},
			},
			<>
				{!noInk && <Ink />}
				<Text inline={true}>{item.displayName}</Text>
				{_superscriptIcon}
			</>,
		);
	}
}
